<template>
  <main>
    <transition name="fade">
      <SplashScreen v-if="isLoading" />
    </transition>
    <Header
      v-show="!isLoading"
      v-on:showLoginModal="loginModalVisible = true"
      v-on:showRegistrationModal="registrationModalVisible = true"
      :activeEvent="activeEvent"
    />
    <Conference v-show="!isLoading" />
    <Lectures v-show="!isLoading" />
    <ActiveEvent :event="activeEvent" v-show="!isLoading" />
    <EventList v-if="!isLoading" />
    <SponsorList v-if="!isLoading" />
    <NoticeBoard v-if="!isLoading" />
    <AppInfo
      v-on:showLoginModal="loginModalVisible = true"
      v-on:showRegistrationModal="registrationModalVisible = true"
      v-show="!isLoading"
    />
    <Gallery :key="galleryKey" v-if="!isLoading" />
    <Contact v-show="!isLoading" />
    <Footer
      v-on:showLoginModal="loginModalVisible = true"
      v-on:showRegistrationModal="registrationModalVisible = true"
      v-show="!isLoading"
    />
    <LoginModal
      v-if="!isLoading && loginModalVisible"
      v-on:close="loginModalVisible = false"
      v-on:showRegistrationModal="
        loginModalVisible = false;
        registrationModalVisible = true;
      "
    />
    <RegistrationModal
      v-if="!isLoading && registrationModalVisible"
      v-on:close="registrationModalVisible = false"
      v-on:showLoginModal="
        registrationModalVisible = false;
        loginModalVisible = true;
      "
    />
    <div
      class="cookie-notice"
      v-bind:style="{
        visibility: isCookieNoticeVisible ? 'visible' : 'hidden',
        opacity: isCookieNoticeVisible ? 1 : 0,
      }"
    >
      <div>
        <span>
          Ova stranica koristi kolačiće za analitiku.
          <br class="connect-on-mobile" />Nastavljanjem se podrazumijeva da ih prihvaćate.
        </span>
      </div>
      <button v-on:click="rememberCookieNotice">U redu</button>
    </div>
  </main>
</template>

<script>
import Header from '@/components/landing-page/Header.vue';
import Conference from '@/components/landing-page/Conference.vue';
import Lectures from '@/components/landing-page/Lectures.vue';
import AppInfo from '@/components/landing-page/AppInfo.vue';
import Contact from '@/components/landing-page/Contact.vue';
import Footer from '@/components/landing-page/Footer.vue';
import SponsorList from '@/components/landing-page/SponsorList.vue';
import NoticeBoard from '@/components/landing-page/NoticeBoard.vue';
import RegistrationModal from '@/components/landing-page/RegistrationModal.vue';
import LoginModal from '@/components/landing-page/LoginModal.vue';
import Gallery from '@/components/landing-page/Gallery.vue';
import EventList from '@/components/landing-page/EventList.vue';
import SplashScreen from '@/views/SplashScreen.vue';
import ActiveEvent from '@/components/landing-page/ActiveEvent.vue';
import { throttle } from '@/config';

export default {
  name: 'LandingPage',
  components: {
    Header,
    Conference,
    Lectures,
    AppInfo,
    Contact,
    Footer,
    Gallery,
    SponsorList,
    NoticeBoard,
    RegistrationModal,
    LoginModal,
    EventList,
    SplashScreen,
    ActiveEvent,
  },
  data() {
    return {
      registrationModalVisible: false,
      loginModalVisible: false,
      splashScreenActive: true,
      galleryKey: 0,
      isCookieNoticeVisible: false,
      activeEvent: null,
    };
  },
  computed: {
    isLoggedIn: function () {
      let token = localStorage.getItem('token');
      if (!token) return false;

      let decoded = this.$decode(token);
      if (!decoded) return false;

      return true;
    },
    isLoading: function () {
      return this.$store.getters['landing/isLoading'];
    },
  },
  methods: {
    rememberCookieNotice: function () {
      this.isCookieNoticeVisible = false;
      localStorage.setItem('didCheckCookieNotice', 'yes');
    },
  },
  beforeCreate() {
    this.$store.dispatch('landing/getLanding');
  },
  mounted() {
    if (!localStorage.getItem('didCheckCookieNotice')) {
      this.isCookieNoticeVisible = true;
    }

    this.$axios.get(`${this.$API_URL}/events/active-lecture`).then(response => {
      this.activeEvent = response.data;
    });

    const flyInObserver = new IntersectionObserver((entries, imgObserver) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const element = entry.target;

          element.style.opacity = 1;
          element.style.transform = 'translate3d(0, 0, 0) rotate(0deg)';

          imgObserver.unobserve(element);
        }
      });
    });

    const toIntersect = document.querySelectorAll('.intersect--fly-in');
    toIntersect.forEach(element => {
      flyInObserver.observe(element);
    });

    window.addEventListener(
      'resize',
      throttle(() => {
        this.galleryKey++;
      }, 200),
    );
  },
};
</script>

<style>
body {
  padding: 0;
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.container {
  max-width: 1120px;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
}

.intersect--fly-in {
  opacity: 0;
  transform: translate3d(-40px, 0, 0) rotate(0deg);
  transition: transform 1s ease-in-out, opacity 1s ease-in-out;
}

.intersect--fly-in--right {
  transform: translate3d(40px, 0, 0) rotate(0deg);
}

.modal {
  font-family: 'Fuse V.2 Display', 'Arial', sans-serif;
  display: flex;
  justify-content: center;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  background-color: #0a181b;
  overflow-y: hidden;
}

.cookie-notice {
  position: fixed;
  bottom: 24px;
  width: 80%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  left: 50%;
  transform: translateX(-50%);
  background-color: #162427;
  padding: 25px 60px;
  border-radius: 20px;
  display: flex;
  justify-content: space-between;
  z-index: 999;
}

.cookie-notice > div {
  font-size: 18px;
  line-height: 1.5;
  color: white;
}

.cookie-notice button {
  text-decoration: none;
  display: inline-block;
  border: none;
  padding: 11px 32px;
  border-radius: 10px;
  background-color: #30cec2;
  color: #0a181b;
  font-size: 16px;
  font-weight: 600;
  outline: 0;
  text-transform: none;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
}

.cookie-notice button:hover {
  background-color: #35e5d8;
}

.cta--primary {
  text-decoration: none;
  display: inline-block;
  border: none;
  padding: 12px 32px;
  border-radius: 15px;
  background-color: #30cec2;
  color: #0a181b;
  font-size: 16px;
  font-weight: 800;
  line-height: 24px;
  outline: 0;
  text-transform: none;
  cursor: pointer;
  transition: box-shadow 0.2s ease-in-out, background-color 0.2s ease-in-out;
}

@media screen and (min-width: 1280px) {
  .lectures__image {
    width: 505px;
    height: 605px;
  }

  .lectures__title {
    font-size: 32px;
    line-height: 38px;
  }
}

@media screen and (max-width: 1024px) {
  .modal {
    overflow-y: scroll;
  }
}

@media screen and (max-width: 900px) {
  .cookie-notice > div {
    font-size: 16px;
    line-height: 20px;
  }
}

@media screen and (max-width: 768px) {
  body {
    overflow-x: hidden;
  }

  .cookie-notice > div {
    font-size: 14px;
    line-height: 18px;
    margin-right: 14px;
  }

  .cookie-notice {
    padding: 20px 30px;
  }
}

@media screen and (max-width: 650px) {
  .cookie-notice > div {
    font-size: 12px;
    line-height: 16px;
  }
}

@media screen and (max-width: 580px) {
  .cookie-notice {
    padding: 20px 10px;
  }

  .cookie-notice button {
    padding: 11px 18px;
  }
}

@media screen and (max-width: 460px) {
  .cookie-notice {
    width: 90%;
  }

  .connect-on-mobile {
    display: none;
  }
}
</style>
